<template>
  <div>
    <header-component/>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Service List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button 
              size="sm" 
              type="primary" 
              @click="createService">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="serviceList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Name" 
            prop="label"/>
          <el-table-column 
            label="Service Category Name" 
            prop="serviceCategory.label"/>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                 <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog 
        :visible.sync="addService" 
        title="Add Service">
        <add-service @close="addService = false"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddService from "./AddService";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addService: false
    };
  },

  computed: {
    ...mapGetters({
      serviceList: "service/getServiceList",
      service: "service/getService"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "add-service": AddService,
    "header-component": headerComponent
  },

  mounted() {
    this.getServiceList();
  },

  methods: {
    ...mapActions({
      getServiceList: "service/getServiceList",
      fetchService: "service/fetchService"
    }),
    ...mapMutations({
      setService: "service/setService",
      resetService: "service/resetService"
    }),
    handleAction(service, command) {
      if (command === "edit") {
        this.fetchService(service.serviceId).then(res => {
          this.addService = true;
          this.setService(res);
        });
      }
    },

    createService() {
      this.resetService();
      this.addService = true;
    }
  }
};
</script>
